var map = {
	"./en/instructions/phase_front_view_instructions_female.png": 5664,
	"./en/instructions/phase_front_view_instructions_male.png": 7659,
	"./en/instructions/phase_side_view_instructions_female.png": 3198,
	"./en/instructions/phase_side_view_instructions_male.png": 1965,
	"./fi/instructions/phase_front_view_instructions_female.png": 3014,
	"./fi/instructions/phase_front_view_instructions_male.png": 8773,
	"./fi/instructions/phase_side_view_instructions_female.png": 524,
	"./fi/instructions/phase_side_view_instructions_male.png": 5975,
	"./sw/instructions/phase_front_view_instructions_female.png": 9944,
	"./sw/instructions/phase_front_view_instructions_male.png": 6116,
	"./sw/instructions/phase_side_view_instructions_female.png": 2951,
	"./sw/instructions/phase_side_view_instructions_male.png": 6528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;